import {
  FETCH_ALL_PROVIDERS,
  FETCH_ALL_PROVIDERS_FAILURE,
  FETCH_ALL_PROVIDERS_SUCCESS,
  TOGGLE_PROVIDER_ACTIVATION,
  TOGGLE_PROVIDER_ACTIVATION_FAILURE,
  TOGGLE_PROVIDER_ACTIVATION_SUCCESS
} from '../constant/actionType';

const initialState = {
  providerToggleState: {
    error: null,
    isLoading: false
  },
  providersState: {
    data: [],
    error: null,
    isLoading: false
  }
};

const providersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_PROVIDERS:
      return {
        ...state,
        providersState: {
          ...state.providersState,
          isLoading: true
        }
      };

    case FETCH_ALL_PROVIDERS_FAILURE:
      return {
        ...state,
        providersState: {
          ...state.providersState,
          error: action.error,
          isLoading: false
        }
      };

    case FETCH_ALL_PROVIDERS_SUCCESS:
      return {
        ...state,
        providersState: {
          ...state.providersState,
          data: action.data,
          error: null,
          isLoading: false
        }
      };
    case TOGGLE_PROVIDER_ACTIVATION:
      return {
        ...state,
        providerToggleState: {
          isLoading: true
        }
      };

    case TOGGLE_PROVIDER_ACTIVATION_FAILURE:
      return {
        ...state,
        providerToggleState: {
          error: action.error,
          isLoading: false
        }
      };

    case TOGGLE_PROVIDER_ACTIVATION_SUCCESS:
      return {
        ...state,
        providerToggleState: {
          error: null,
          isLoading: false
        }
      };

    default:
      return state;
  }
};
export default providersReducer;
